import { render, staticRenderFns } from "./CheckboxButton.vue?vue&type=template&id=1a305f4c&"
import script from "./CheckboxButton.vue?vue&type=script&lang=js&"
export * from "./CheckboxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports